<template>
  <component :is="VALUE_TYPE_TO_COMPONENT[value.valueType]" :value="value" />
</template>
<script lang="ts" setup>
import NumberValue from './STaskStateNumber.vue';
import ChemicalIsotopeValue from './STaskStateChemicalIsotope.vue';
import ChemicalElementValue from './STaskStateChemicalElement.vue';
import IntegerValue from './STaskStateInteger.vue';
import StringValue from './STaskStateString.vue';
import {TaskVariableValue} from '../types/entities/tasks';

const VALUE_TYPE_TO_COMPONENT = {
  NumberValue,
  ChemicalIsotopeValue,
  ChemicalElementValue,
  IntegerValue,
  StringValue,
};

defineProps<{
  value: TaskVariableValue;
}>();
</script>
